// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SystemFactors_wrapper__6x62y","content":"SystemFactors_content__3ocwP","table":"SystemFactors_table__VMOPX","subtitle":"SystemFactors_subtitle__1HnXV"};